import * as React from 'react';
import hopeTheme from './themes/hopeTheme';

// pulled from host a tasting / become a ceo mocks
export const cardBoxShadow = '0 3px 5px 0 rgba(0, 0, 0, 0.25)';

export const imageDialogStyle = {
  minWidth: '90%',
  maxWidth: 'none',
  height: '100%',
  overflowY: 'auto',
};

export const imageDialogStyleMobile = {
  width: '100%',
  minWidth: '100%',
  padding: 0,
  transform: 'translate(0, 0)',
};

export const toolBarTitleStyle = {
  style: {
    color: '#666',
    textTransform: 'uppercase',
    fontFamily: hopeTheme.headerBold,
    letterSpacing: 1.4,
    fontSize: 16,
    fontWeight: 400,
    paddingLeft: 24,
    paddingRight: 24,
  },
};

export const toolBarPurple = {
  padding: '6px 16px',
  color: 'white',
  backgroundColor: hopeTheme.hopeLightPurple,
  fontWeight: 400,
  fontFamily: hopeTheme.headerBold,
  textTransform: 'uppercase',
  letterSpacing: '1.4px',
  fontSize: 16,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const toolBarGreyCheckout = {
  padding: '6px 16px',
  color: hopeTheme.toolBar.toolBarGreyText,
  backgroundColor: hopeTheme.toolBar.toolBarGrey,
  fontWeight: 600,
  fontFamily: hopeTheme.headerBold,
  textTransform: 'uppercase',
  letterSpacing: '1.4px',
  fontSize: 18,
  marginBottom: 24,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const toolBarGrey = {
  padding: '6px 16px',
  color: hopeTheme.toolBar.toolBarGreyText,
  backgroundColor: hopeTheme.toolBar.toolBarGrey,
  fontWeight: 600,
  fontFamily: hopeTheme.headerBold,
  textTransform: 'uppercase',
  letterSpacing: '1.4px',
  fontSize: 18,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const toolBarWhite = {
  padding: '6px 16px',
  color: hopeTheme.hopeBlack,
  backgroundColor: 'white',
  fontWeight: 600,
  fontFamily: hopeTheme.headerBold,
  textTransform: 'uppercase',
  fontSize: 18,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const customContentFullWidthStyle = {
  width: '100%',
  maxWidth: '600px',
  height: '100%',
  overflowY: 'auto',
} as React.CSSProperties;

export const customContentStyle = {
  width: '100%',
  maxWidth: '524px',
  height: '100%',
  overflowY: 'auto',
} as React.CSSProperties;

export const bodyStyleMobile = {
  padding: 24,
  minHeight: 'calc(65vh)',
  overflowY: 'auto',
} as React.CSSProperties;

export const bodyStyle = {
  padding: '20px 20px 100px 20px',
  overflowY: 'auto',
} as React.CSSProperties;

export const customContentStyleMobile = {
  width: '100%',
  minWidth: '100%',
  padding: 0,
  transform: 'translate(0, 0)',
};

export const dialogStyle = {
  zIndex: 8000,
  paddingTop: 0,
  minHeight: '100vh',
  position: 'fixed',
} as React.CSSProperties;

export const dialogSummaryStyle = {
  color: hopeTheme.hopeBlack,
  fontFamily: hopeTheme.headerMedium,
  fontSize: '14px',
  fontWeight: 300,
  lineHeight: '26px',
  margin: '0 0 20px 0',
} as React.CSSProperties;

export const actionsContainerStyle = {
  padding: '0',
  backgroundColor: hopeTheme.toolBar.toolBarGrey,
  zIndex: 100000,
} as React.CSSProperties;

export const tabsStyles = {
  inkBarStyle: { display: 'none' },
  tabItemContainerStyle: {
    backgroundColor: '#f6f6f6',
    top: 90,
    zIndex: 15,
    width: 600,
    margin: '0 auto',
    marginTop: 0,
    borderTop: '0px solid #e1e1e1',
    borderBottom: '0px solid #e1e1e1',
  },
};

export const tabsStylesMobile = {
  inkBarStyle: { display: 'none' },
  tabItemContainerStyle: {
    backgroundColor: '#f6f6f6',
    position: 'fixed',
    top: 100,
    zIndex: 15,
    width: '100%',
    marginTop: 0,
    borderTop: '1px solid #e1e1e1',
    borderBottom: '1px solid #e1e1e1',
  },
};
